import { ActionTagRenderProps } from 'components/action-tag/action-tag-component';
import { useResolvePatientUserAddQuestions } from '../hooks/useResolvePatientUserAddQuestions';
import { PatientRecord } from '../types';
import { TagEditDetails } from 'features/clinician/clinic-user-management/components/tag-edit-details';
import { TableRow } from '../../user-table-types';

export function ActionTagEdit(
  props: { clinicId: string } & ActionTagRenderProps<TableRow<PatientRecord>>
) {
  const { clinicId, ..._props } = props;
  const patientUserAddQuestions = useResolvePatientUserAddQuestions(clinicId);
  return (
    <TagEditDetails
      {..._props}
      userAddQuestions={patientUserAddQuestions}
      initialValues={{
        firstName: _props.record.firstName,
        lastName: _props.record.lastName,
        email: _props.record.email,
        phoneNumber: _props.record.raw.phoneNumber,
        assessmentType: _props.record.raw.nextAssessmentType,
        clinicianId: (_props.record.raw as any).assignedClinicians
          .map((_: any) => `${_.id}`)
          .join(', ')
      }}
    />
  );
}
